import { marketReportRoutes } from './lib/market-report.routes';
export default marketReportRoutes;
